import type { Logger, LoggerConfig, LoggerOptions, LogLevel } from '@/types/Logger';
import type { LogEntry } from '@/types/LogEntry';

export abstract class LoggerService {
  abstract createLogger(options: LoggerOptions): Logger;
  abstract configure(config: LoggerConfig): void;
  abstract enable(pattern: string): void;
  abstract disable(pattern: string): void;
  abstract disableAll(): void;
  abstract refreshFromStorage(): void;
  /** Captured log lines, oldest first. Entries are retained before the enabled/level
   * console gate, so suppressed `debug`/`trace` lines are included. */
  abstract getRecentLogs(): LogEntry[];
  abstract clearLogs(): void;
  /** The currently enabled `DEBUG` namespace patterns (verbatim; disabled patterns
   * and `disableAll()` state are not reflected). */
  abstract getEnabledPatterns(): string[];
  abstract getLevel(): LogLevel;
}
